import React, { memo } from 'react';

import styled from 'styled-components';

import { Col, Row } from '../../atoms/Grid';
import Image from '../../atoms/Image/Image';
import Text from '../../atoms/Text/Text';

import { localizedMoment } from '@utils/localizedMoment';

import { I18nTranslation } from '@shared/interfaces/i18n';
import { withTranslation } from 'i18n';

type SubscriptionInfoProps = {
  hasExpired: boolean;
  licenseImage: string;
  licenseName: string;
  appName: string;
  purchasedDate: string;
  format: string;
  extraComponent?: () => void;
  t: I18nTranslation;
};

function SubscriptionInfo({
  hasExpired,
  licenseImage,
  licenseName,
  appName,
  purchasedDate,
  format,
  extraComponent,
  t: tProp,
}: SubscriptionInfoProps) {
  const t = (key, options?) => tProp(`subs.${key}`, options);

  const color = hasExpired ? 'osloGray' : 'cornflowerBlue';
  const dateMessage = hasExpired
    ? t('licenseExpired')
    : t('purchased', { date: localizedMoment(purchasedDate, format) });

  return (
    <>
      <Row>
        <Col auto>
          <ImageExtend
            hasExpired={hasExpired}
            src={licenseImage}
            width={4.75}
            mWidth={5.25}
          />
        </Col>
        <Col>
          <Text
            component="div"
            smSize={1.375}
            size={1.5}
            weight="bold"
            lineHeight={1.3}
            color={color}
          >
            {licenseName}
          </Text>
          <Text component="div" size={1.125} lineHeight={1.5} color={color}>
            <span dangerouslySetInnerHTML={{ __html: appName }} />
          </Text>
          <Text component="div" size={1.125} lineHeight={1.5} color={color}>
            {dateMessage}
          </Text>
        </Col>
      </Row>

      {extraComponent && extraComponent()}
    </>
  );
}

const ImageExtend = styled(Image)<{ hasExpired: boolean }>`
  ${props =>
    props.hasExpired &&
    `
    opacity: .5;
  `}
`;

export default memo(withTranslation('account')(SubscriptionInfo));
